import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { isMobileOrTablet } from '@/api/checkMobileDevices';
import checkItemCount from '@/api/checkItemCount';
import isNumber from '@/api/isNumber';
import { Product, UpdateProductCountEvent } from '@/api/product';
import autoSelect from '@/api/autoSelect';

export default abstract class ProductListElementAbstract extends Vue {
    @Prop() product!: Product
    @Prop({ default: '' }) unsecured!: String
    count = +this.product.quantity
    get basketCount() {
      let ind = this.$store.getters.basketProducts.findIndex(
        (product: Product) => {
          return product.Артикул === this.product.Артикул;
        }
      );
      if (ind !== -1)
        return +(this.$store.getters.basketProducts[ind].quantity as string);
      return 0;
    };
    get isMobileOrTablet() {
        return isMobileOrTablet()
    }

    /*openAndAddToBasket() {
        this.$store.dispatch('addItemToBasket', {
            item: {},
            quiet: this.$vuetify.breakpoint.xsOnly ? false : true 
        })
        if (this.$vuetify.breakpoint.smAndUp) this.$emit('dialog', true)
    }*/
    addToBasket() {
        this.$store.dispatch('addProductToBasket', {
            product: this.product,
            quiet: false
        })
        this.$nextTick(() => this.updateCount(1))

        if ((document as any).activeElement) (document as any).activeElement.blur();
    }

    updateCount(count: number) {
        let oldVal = this.count;
        this.count = count;
        this.$nextTick(() => {
            this.count = checkItemCount(+count, oldVal);
            let updateProductCountEvent: UpdateProductCountEvent = {
                count: this.count,
                vCode: this.product.Артикул
            }
            this.$emit('updateProductCount', updateProductCountEvent)
        })
    }
    numberFilter(e: KeyboardEvent, count: number) {
        if (!isNumber(e.key)) e.preventDefault();
    }
    autoSelect = autoSelect
    showImage() {
        this.$store.commit('image:show', this.product.Фото)
    }
    deleteUnsecuredItem(){
        this.$emit('deleteUnsecuredItem', this.product.Артикул)
    }
}